import siteConfig from "site-config";
import { baseActionEpic, IRequestAction, IRequestDataAction, progressEpic } from "./base-epic";
import { CANCELLED_STYLES } from "constants/action-types";
import { IOrderDetails } from "components/orders/orders-types";
import { ICancelledStyle } from "constants/cancelled-styles-types";
import { IDropPayload, IOrderStylesPayload } from "reducers/cancelled-styles-reducers";
import { add as snackbarAdd } from "actions/snackbars";
import { format as t } from "lib/globalize-util";

export const getOrdersCount = baseActionEpic<IRequestAction>(
    CANCELLED_STYLES.ORDERS.COUNT,
    ({ payload }) => ({ method: "GET", url: siteConfig.api + payload.url, activeBrand: payload.activeBrand }),
    ({ response }) => [{ type: CANCELLED_STYLES.ORDERS.UPDATE, payload: { count: response } }],
);

export const getStylesCount = baseActionEpic<IRequestAction>(
    CANCELLED_STYLES.STYLES.COUNT,
    ({ payload }) => ({ method: "GET", url: siteConfig.api + payload.url, activeBrand: payload.activeBrand }),
    ({ response }) => [{ type: CANCELLED_STYLES.STYLES.UPDATE, payload: { count: response } }],
);

export const getCanceledStyles = progressEpic<IRequestAction, ICancelledStyle[]>(
    CANCELLED_STYLES.STYLES.FETCH,
    ({ payload }) => ({ method: "GET", url: siteConfig.api + payload.url }),
    {
        dataCustomizer: (response, action, store) =>
            action.payload.next ? store.cancelledStyles.styles.payload.concat(response) : response,
    },
);

export const getCanceledStylesOrderEpic = progressEpic<IRequestAction, IOrderDetails>(
    CANCELLED_STYLES.ORDER.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    }),
);

export const getCancelledStyle = progressEpic<IRequestAction, ICancelledStyle>(
    CANCELLED_STYLES.STYLE.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    }),
);

export const dropStylesEpic = progressEpic<IRequestDataAction<{ orders: string[]; products: string[] }>, IDropPayload>(
    CANCELLED_STYLES.DROP,
    ({ payload }) => ({ method: "POST", url: siteConfig.api + payload.url, body: payload.body }),
    {
        finishActions: () => [snackbarAdd({ message: t("Order(s) for cancelled styles updating") })],
    },
);

export const getOrderStyles = progressEpic<IRequestAction, IOrderStylesPayload>(
    CANCELLED_STYLES.ORDER_STYLES.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    }),
);
